import { Button, Form, Input, Space } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { drawError } from "../utils/utils";
import Cookies from 'js-cookie';
import { apiCall } from "../utils/Api";

export default function Login(props) {

    const {
        session = {},
        setSession = () => { },
        loading = false,
        setLoading = () => { },
        path_id = "",
        globals = {},
        setGlobals = () => { },
        setWorkStation = () => { },
    } = props;

    const [email, setEmail] = useState("");
    const [pass, setPass] = useState("");
    const [fetching, setFetching] = useState(true);
    const filled = (email && pass) ? true : false;




    const bypass = (_code, _store, _st) => {
        apiCall("account/bizToBmo", { store_id: 298, corp_id: _store }, (_s, _r) => {
            if (_s) {
                window.credentials = {
                    socket_url: "wss://" + _r.url + "/ws/",
                    ticket: _r.ticket,
                    store_id: _store,
                    station: _code,
                    name: _st?.name
                }

                setGlobals({ ...globals, "connect": true });
                window.history.replaceState(null, '', '/' + _store.toString());
            }
        });
    }


    const onConnect = () => {
        if (globals?.ready) {
            let _saved = Cookies.get("workstation");
            if (_saved) {
                let _split = _saved.split("-");
                if (_split.length === 2) {
                    window.can_call = true;
                    setWorkStation(window.credentials.station, window.credentials.store_id);
                    return;
                }
            }
        }
    }


    useEffect(onConnect, [globals])


    const getSession = () => {


        setLoading(true);
        let _obj = {};
        if (Cookies.get("bmo_session_id")) {
            _obj.session_id = Cookies.get("bmo_session_id");
        }

        apiCall("session/get", _obj, (_s, _r) => {
            if (_s) {
                window.sitesettings = _r;
                Cookies.set("bmo_session_id", _r.session_id, { expires: 14 });
                // Check if store and station are saved to bypass
                if (_r.logged_in) {



                    let _saved = Cookies.get("workstation");
                    if (_saved) {
                        let _split = _saved.split("-");
                        if (_split.length === 2) {
                            if (path_id && _r.available_corps.find(item => item.id == path_id)) {
                                let _store = _r.available_corps.find(item => item.id == path_id) || { name: "" };
                                bypass(_split[0], _split[1], _store);
                                return;
                            } else {
                                let _store2 = _r.available_corps.find(item => item.id == _split[1]);
                                if (_store2) {
                                    bypass(_split[0], _split[1], _store2);
                                    return;
                                } else {
                                    setSession(_r);
                                }
                            }
                        } else {
                            setSession(_r);
                        }
                    } else {
                        setSession(_r);
                    }
                } else {
                    setFetching(false)
                    Cookies.set("workstation", "", { expires: 14 });
                    setSession(_r);
                }

            } else {
                drawError(_r.error)
                setFetching(false)
            }
            setLoading(false);
        })
    }

    useEffect(getSession, [])


    const login = () => {
        let obj = {
            session_id: session.session_id,
            password: pass,
        }

        if (email.includes("@")) {
            obj.email_address = email;
        } else {
            obj.san = email;
        }

        setLoading(true);
        apiCall("account/login", obj, (_s, _r) => {
            if (_s) {

                if (_r.logged_in) {
                    let _saved = Cookies.get("workstation");
                    if (_saved) {
                        let _split = _saved.split("-");
                        if (_split.length === 2) {
                            if (_split[1] === path_id) {
                                bypass(_split[0], _split[1]);
                                return;
                            }
                        }
                    }
                }

                Cookies.set("workstation", "", { expires: 14 });
                setSession(_r);
            } else {
                drawError(_r.error)
            }
            setLoading(false);
        })

    }

    if (fetching) {
        return (<></>)
    }

    return (
        <>
            <div>
                <big><span style={{ "opacity": "0.5" }}>Login with Biz credentials</span></big><br /><br />
                <div style={{ "padding": "30px", "paddingTop": "20px" }}>
                    <div style={{ "textAlign": "left", "padding": "5px 15px", "opacity": "0.5" }}>Email address / SAN</div>
                    <Form.Item className="login-input" style={{ "textAlign": "left" }}>
                        <Input value={email} onChange={(e) => setEmail(e)} clearable placeholder="Email address / SAN" />
                    </Form.Item><br />
                    <div style={{ "textAlign": "left", "padding": "5px 15px", "opacity": "0.5" }}>Password</div>
                    <Form.Item className="login-input" style={{ "textAlign": "left" }}>
                        <Input value={pass} onChange={(e) => setPass(e)} clearable type="password" placeholder="Enter your password" />
                    </Form.Item><br /><br />
                    <Space block direction="vertical">
                        <Button onClick={() => {
                            if (filled) {
                                login();
                            }
                        }} disabled={!filled} color={(filled) ? "primary" : "default"} block>Login</Button>
                    </Space>
                </div><br /><br />
            </div>
        </>)
}